import { Routes } from "@angular/router";
import { LogoutGuard } from "src/app/_helpers/logout.guard";
import { BookingFormComponent } from "src/app/pages/artist/booking-form/booking-form.component";
import { ConfirmationComponent } from "src/app/pages/commons/confirmation/confirmation.component";
import { ConnectWithComponent } from "src/app/pages/commons/connect-with/connect-with.component";
import { LoginComponent } from "src/app/pages/commons/login/login.component";
import { MapComponent } from "src/app/pages/artist/map/map.component";
import { RegisterComponent } from "src/app/pages/commons/register/register.component";
import { ResetPasswordComponent } from "src/app/pages/commons/reset-password/reset-password.component";
import { PasscultureComponent } from "src/app/pages/commons/passculture/passculture.component";
import { OldStudioComponent } from "src/app/pages/commons/old-studio/old-studio.component";
import { PaymentHelpComponent } from "src/app/pages/commons/payment-help/payment-help.component";
import { MentionsLegalesComponent } from "src/app/pages/commons/mentions-legales/mentions-legales.component";
import { PolitiqueConfidentialiteComponent } from "src/app/pages/commons/politique-confidentialite/politique-confidentialite.component";
import { PolitiqueCookiesComponent } from "src/app/pages/commons/politique-cookies/politique-cookies.component";
import { CguvUserComponent } from "src/app/pages/commons/cguv-user/cguv-user.component";
import { CguvCompanyComponent } from "src/app/pages/commons/cguv-company/cguv-company.component";
import { BookingFormTestComponent } from "src/app/pages/artist/booking-form-test/booking-form-test.component";
import { CharteStudiomapComponent } from "src/app/pages/commons/charte-studiomap/charte-studiomap.component";

export const AuthLayoutRoutes: Routes = [
  { path: "carte", component: MapComponent },
  { path: "login", component: LoginComponent, canActivate: [LogoutGuard] },
  {
    path: "register",
    component: RegisterComponent,
    canActivate: [LogoutGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [LogoutGuard],
  },
  {
    path: "confirmation",
    component: ConfirmationComponent,
    canActivate: [LogoutGuard],
  },
  { path: "connect-with", component: ConnectWithComponent },
  { path: "booking-form", component: BookingFormComponent },
  //{ path: "booking-form-test", component: BookingFormTestComponent },
  { path: "passculture", component: PasscultureComponent },
  { path: "fiche-studio/:id", component: OldStudioComponent },
  { path: "artiste/fiche-studio/:id", component: OldStudioComponent },
  { path: "payment-help", component: PaymentHelpComponent },
  { path: "mentions-legales", component: MentionsLegalesComponent },
  {
    path: "politique-confidentialite",
    component: PolitiqueConfidentialiteComponent,
  },
  { path: "politique-cookies", component: PolitiqueCookiesComponent },
  { path: "cguv-company", component: CguvCompanyComponent },
  { path: "cguv-user", component: CguvUserComponent },
  { path: "charte-studiomap", component: CharteStudiomapComponent },
];
